import { createContext, useContext } from "react";

export const ApiContext = createContext();

export function useApiContext() {
  return useContext(ApiContext);
}
